// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Grid,
//   Button,
//   Modal,
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead, MenuItem,
//   TableRow, Select, FormControl,
//   InputLabel, IconButton,
//   TextField, TablePagination, Divider,
//   Paper, FormControlLabel, Radio, RadioGroup
// } from "@mui/material";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import Switch from '@mui/material/Switch';
// import { styled } from '@mui/material/styles';


// const ModalTable = ({ open, handleClose, data, externalStudents, answers, assessments, fetchAnswers }) => {
//   const [search, setSearch] = useState("");
//   const [filter, setFilter] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [fileModalOpen, setFileModalOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [grading, setGrading] = useState("");
//   const [score, setScore] = useState(null);
//   const [comments, setComments] = useState("");
//   const [moduleName, setModuleName] = useState("");
//   const [selectedId, setSelectedId] = useState(null);
//   const approver = decryptData(localStorage.getItem('name'));
//   const [loading, setLoading] = useState(false);
//   const [verified, setVerified] = useState(false);
//   const [existingStatus, setExistingStatus] = useState(false);

//   const [switchloading, setswitchLoading] = useState(false);

//   // Handle score input, clear grading if score is enteredF
//   const handleScoreChange = (event) => {
//     let value = event.target.value;

//     // Allow only numbers and limit to 100
//     if (value === "" || (/^\d+(\.\d{0,2})?$/.test(value) && Number(value) <= 100)) {
//       setScore(value === "" ? null : Number(value));
//       setGrading(""); // Clear grading when score is entered
//     }
//   };

//   // Ensure data.moduleName exists before filtering
//   if (!data || !data.moduleName) {
//     console.error("Error: data.moduleName is undefined!");
//     return null; // Prevents rendering if data is invalid
//   }

//   // Fetch assessments for the current module only
//   const moduleAssessments = assessments.filter(assessment => assessment.moduleName === data.moduleName);

//   // If there are no assessments for the module, do not render student rows
//   if (moduleAssessments.length === 0) {
//     return (
//       <Modal open={open} onClose={handleClose}>
//         <Box sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "90%",
//           height: "80%",
//           bgcolor: "background.paper",
//           boxShadow: 24,
//           p: 4,
//           overflow: "auto",
//         }}>
//           <Typography variant="h6">No assessments available for this module.</Typography>
//           <Button onClick={handleClose} variant="contained" sx={{ mt: 2 }}>Close</Button>
//         </Box>
//       </Modal>
//     );
//   }

//   // Combine external students with their completion status, file URL, and assessments
//   const studentsWithStatus = externalStudents.map(student => {
//     const studentAnswers = answers.filter(answer => answer.studentId === student.id && answer.moduleName === data.moduleName);

//     // Create a list of assessments with their descriptions and status for the current student
//     const studentAssessments = moduleAssessments.map(assessment => {
//       const assessmentAnswer = studentAnswers.find(answer => answer.trentAssessmentId === assessment.id);
//       return {
//         description: assessment.description,
//         status: assessmentAnswer ? "Completed" : "Not Completed",
//         submittedAt: assessmentAnswer ? assessmentAnswer.submittedAt : null, // Get submitted date if available
//         url: assessmentAnswer ? assessmentAnswer.url : null,
//         grade: assessmentAnswer ? assessmentAnswer.grade : null, // Get URL if available
//         comments: assessmentAnswer ? assessmentAnswer.comments : null,
//         id: assessmentAnswer ? assessmentAnswer.id : null,
//         verified: assessmentAnswer ? assessmentAnswer.verified : false, // Get verified status if available
//       };
//     });

//     return {
//       student: student.name,
//       module: data.moduleName,
//       assessments: studentAssessments,
//     };
//   });

//   // console.log("hello",studentsWithStatus)
//   // Apply search and filter (if needed)
//   const filteredData = studentsWithStatus.filter(row =>
//     row.student.toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSave = async () => {
//     setLoading(true); // Start loader
//     try {
//       const response = await axios.put(`/submissions/update/${selectedId}`, {
//         moduleName: moduleName,
//         grade: score,
//         comments: comments,
//         approver: approver,
//       });

//       console.log("Submission updated successfully:", response.data);
//       toast.success("Mark updated successfully");
//     } catch (error) {
//       console.error("Error updating submission:", error);
//     } finally {
//       setLoading(false); // Stop loader
//       setFileModalOpen(false); // Close modal after saving
//       fetchAnswers();
//     }
//   };

//   const handleViewClick = (assessment, row) => {
//     setModuleName(row.module);
//     setSelectedFile(assessment.url);
//     setSelectedId(assessment.id);
//         setVerified(assessment.verified)
//     setScore(assessment.grade || 0); // Set score from assessment, default to 0 if not available
//     // setExistingStatus(assessment.verified)
//     setComments(assessment.comments || ""); // Set comments from assessment
//     setFileModalOpen(true); // Open modal
//   };


//   const IOSSwitch = styled((props) => (
//     <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
//   ))(({ theme }) => ({
//     width: 42,
//     height: 26,
//     padding: 0,
//     '& .MuiSwitch-switchBase': {
//       padding: 0,
//       margin: 2,
//       transitionDuration: '300ms',
//       '&.Mui-checked': {
//         transform: 'translateX(16px)',
//         color: '#fff',
//         '& + .MuiSwitch-track': {
//           backgroundColor: '#65C466',
//           opacity: 1,
//           border: 0,
//           ...theme.applyStyles('dark', {
//             backgroundColor: '#2ECA45',
//           }),
//         },
//         '&.Mui-disabled + .MuiSwitch-track': {
//           opacity: 0.5,
//         },
//       },
//       '&.Mui-focusVisible .MuiSwitch-thumb': {
//         color: '#33cf4d',
//         border: '6px solid #fff',
//       },
//       '&.Mui-disabled .MuiSwitch-thumb': {
//         color: theme.palette.grey[100],
//         ...theme.applyStyles('dark', {
//           color: theme.palette.grey[600],
//         }),
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         opacity: 0.7,
//         ...theme.applyStyles('dark', {
//           opacity: 0.3,
//         }),
//       },
//     },
//     '& .MuiSwitch-thumb': {
//       boxSizing: 'border-box',
//       width: 22,
//       height: 22,
//     },
//     '& .MuiSwitch-track': {
//       borderRadius: 26 / 2,
//       backgroundColor: '#E9E9EA',
//       opacity: 1,
//       transition: theme.transitions.create(['background-color'], {
//         duration: 500,
//       }),
//       ...theme.applyStyles('dark', {
//         backgroundColor: '#39393D',
//       }),
//     },
//   }));



//   const handleToggle = async (event) => {
//     const newValue = event.target.checked;
//     setVerified(newValue); // Optimistic update
//     setswitchLoading(true);

//     try {
//       await axios.patch(`/submissions/${selectedId}/verify`, {
//         verified: newValue,
//       });
//     } catch (error) {
//       console.error('Failed to update verified status:', error);
//       setVerified(!newValue); // Revert on failure
//     } finally {
//       setLoading(false);
//          fetchAnswers(); // Fetch updated answers after toggling
//     }
//   };



//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={{
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         width: "90%",
//         height: "80%",
//         bgcolor: "background.paper",
//         boxShadow: 24,
//         p: 4,
//         overflow: "auto",
//       }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//           <Typography variant="h5">Batch Details</Typography>
//           <IconButton onClick={handleClose}><CloseIcon /></IconButton>
//         </Box>

//         <Box display="flex" gap={2} mb={2}>
//           <TextField label="Search by Name"
//             variant="outlined"
//             fullWidth
//             value={search}
//             onChange={(e) => setSearch(e.target.value)} />
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={filter} onChange={(e) => setFilter(e.target.value)} label="Status Filter">
//               <MenuItem value="">All</MenuItem>
//               <MenuItem value="Completed">Completed</MenuItem>
//               <MenuItem value="Not Completed">Not Completed</MenuItem>
//             </Select>
//           </FormControl>
//         </Box>

//         <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: "auto" }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow sx={{ bgcolor: "#f5f5f5" }}>
//                 <TableCell style={{ fontWeight: 'bold' }}>Student Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Module Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Assessment Description</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Submitted At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredData.length > 0 ? (
//                 filteredData.filter(row => filter === "" || row.assessments.some(assessment => assessment.status === filter))
//                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
//                     row.assessments.map((assessment, assessmentIndex) => (
//                       <TableRow key={`${index}-${assessmentIndex}`}>
//                         {assessmentIndex === 0 && <TableCell rowSpan={row.assessments.length}>{row.student}</TableCell>}
//                         <TableCell>{row.module}</TableCell>
//                         <TableCell>{assessment.description}</TableCell>
//                         <TableCell>{assessment.status}</TableCell>
//                         <TableCell>{assessment.submittedAt ? new Date(assessment.submittedAt).toLocaleString() : 'N/A'}</TableCell>
//                         <TableCell>
//                           {assessment.url && (
//                             <Button
//                               variant="contained"
//                               color="primary"
//                               onClick={() => handleViewClick(assessment, row)}>
//                               View
//                             </Button>

//                           )}
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={6} align="center">No data available</TableCell>
//                 </TableRow>
//               )}
//             </TableBody>


//             <Modal open={fileModalOpen} onClose={() => setFileModalOpen(false)}>
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(-50%, -50%)",
//                   width: { xs: "90%", sm: "80%" },
//                   height: { xs: "90%" },
//                   bgcolor: "white",
//                   boxShadow: 24,
//                   p: { xs: 2, md: 4 },
//                   borderRadius: 2,
//                   overflow: "hidden",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 {/* Header */}
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>

//                   <Typography variant="h4" fontWeight="bold" color="primary">
//                     Grading & File Preview
//                   </Typography>


//                   <Divider sx={{ mb: 2 }} />

//                   <IconButton onClick={() => setFileModalOpen(false)}>
//                     <CloseIcon />
//                   </IconButton>
//                 </Box>

//                 {/* Content */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: { xs: "column", md: "row" },
//                     flexGrow: 1,
//                     gap: 2,
//                     overflowY: "auto"
//                   }}
//                 >
//                   {/* Left - Grading, Score & Comments */}
//                   <Box
//                     sx={{
//                       flex: 1,
//                       p: 2,
//                       borderRight: { md: "1px solid #ccc" },
//                       borderBottom: { xs: "1px solid #ccc", md: "none" }
//                     }}
//                   >


//                     {/* Score Input */}
//                     <Typography variant="h5" sx={{ mt: 2, color: 'black' }}>
//                       Enter Mark (out of 100)
//                     </Typography>
//                     <TextField
//                       type="text"
//                       fullWidth
//                       value={score}
//                       onChange={handleScoreChange}
//                       placeholder="Enter score (e.g., 85%)"
//                       disabled={grading !== ""}
//                       inputProps={{ pattern: "[0-9]*", inputMode: "numeric", maxLength: 5 }}
//                       sx={{ mt: 1 }}
//                     />

//                     {/* Comments Section */}
//                     <Typography variant="h5" sx={{ mt: 2, color: 'black' }}>
//                       Comments
//                     </Typography>
//                     <TextField
//                       multiline
//                       rows={3}
//                       fullWidth
//                       value={comments}
//                       onChange={(e) => setComments(e.target.value)}
//                       placeholder="Enter comments..."
//                       sx={{ mt: 1 }}
//                     />

//                     {/* <FormControlLabel
//                       control={
//                         <IOSSwitch
//                           checked={verified}
//                           onChange={handleToggle}
//                            disabled={loading || !score}
//                         />
//                       }
//                       label="Approve"
//                     /> */}
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         backgroundColor: '#f5f5f5',
//                         borderRadius: 2,
//                         p: 2,
//                         mt: 3,
//                         boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                       }}
//                     >
//                       <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
//                         Approve
//                       </Typography>
//                       <IOSSwitch
//                         checked={verified}
//                         onChange={handleToggle}
//                         disabled={loading || !score}
//                       />
//                     </Box>

//                   </Box>

//                   {/* Right - File Preview */}
//                   <Box sx={{ flex: 2, p: 2 }}>
//                     <Typography variant="h5" sx={{ color: 'black' }} gutterBottom>
//                       File Preview
//                     </Typography>
//                     {selectedFile ? (
//                       <iframe
//                         src={selectedFile}
//                         width="100%"
//                         height="800px"
//                         title="File Viewer"
//                         style={{ border: "1px solid #ccc", borderRadius: "8px" }}
//                       />
//                     ) : (
//                       <Typography>No file available</Typography>
//                     )}
//                   </Box>
//                 </Box>

//                 {/* Bottom - Save Button */}
//                 <Box display="flex" justifyContent="flex-end" mt={2}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={handleSave}
//                     disabled={loading || (!grading && !score)}
//                     sx={{ px: 3, py: 1, display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
//                   </Button>
//                 </Box>
//               </Box>
//             </Modal>


//           </Table>
//         </TableContainer>

//         <TablePagination
//           rowsPerPageOptions={[5, 10, 15]}
//           component="div"
//           count={filteredData.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={(event, newPage) => setPage(newPage)}
//           onRowsPerPageChange={(event) => setRowsPerPage(parseInt(event.target.value, 10))}
//         />
//         <Button onClick={handleClose} variant="contained" sx={{ mt: 2 }}>Close</Button>
//       </Box>
//     </Modal>
//   );
// };


// const Module = () => {
//   const [openIndex, setOpenIndex] = useState(null);
//   const [batchDetails, setBatchDetails] = useState(null);
//   const [externalStudents, setExternalStudents] = useState([]);
//   const [answers, setAnswers] = useState([]);
//   const [assessments, setAssessments] = useState([]);


//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   const intakeId1 = decryptData(decodeURIComponent(intakeId))

//   const handleOpen = (index) => {
//     setOpenIndex(index);
//     fetchAssessments(batchDetails.moduleDetails[index].moduleName); // Fetch assessments for the selected module
//   };

//   const handleClose = () => setOpenIndex(null);

//   const fetchAssessments = async (moduleName) => {
//     try {
//       const response = await axios.get(`trent_assessments/${batchId1}/${moduleName}`);
//       setAssessments(response.data);
//     } catch (error) {
//       console.error("Error fetching assessments:", error);
//     }
//   };

//   const fetchBatchDetails = async () => {
//     try {
//       const response = await axios.get(`batch/${batchId1}`);
//       setBatchDetails(response.data);
//     } catch (error) {
//       console.error('Error fetching batch details:', error);
//     }
//   };

//   const fetchStudentsByIntake = async () => {
//     try {
//       const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
//       const externalData = response.data;
//       setExternalStudents(externalData);
//     } catch (error) {
//       console.error('Error fetching external data:', error);
//     }
//   };


//   const fetchAnswers = async () => {
//     try {
//       const response = await axios.get(`submissions/intake/${intakeId1}`);
//       setAnswers(response.data);
//     } catch (error) {
//       console.error("Error fetching assessments:", error);
//     }
//   };

//   useEffect(() => {

//     fetchAnswers();
//     fetchBatchDetails();
//     fetchStudentsByIntake();
//   }, [batchId1, intakeId1]);

//   return (
//     <Container>
//       <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
//         {batchDetails?.moduleDetails?.map((module, index) => (
//           <Grid item xs={12} sm={6} md={4} key={module.id}>
//             <Button
//               variant="outlined"
//               fullWidth
//               sx={{
//                 width: "100%", // Ensures all buttons take full width of the grid
//                 minHeight: "80px", // Keeps all buttons at least this tall
//                 maxHeight: "120px", // Prevents excessive growth
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 textAlign: "center",
//                 fontSize: "1rem",
//                 padding: "10px",
//                 whiteSpace: "normal", // Allows text to wrap
//                 wordBreak: "break-word", // Breaks words if necessary
//               }}
//               onClick={() => handleOpen(index)}
//             >
//               {module.moduleName}
//             </Button>
//           </Grid>

//         ))}
//       </Grid>
//       {openIndex !== null && (
//         <ModalTable
//           open={true}
//           handleClose={handleClose}
//           data={batchDetails?.moduleDetails[openIndex]}
//           externalStudents={externalStudents}
//           answers={answers}
//           assessments={assessments}
//           fetchAnswers={fetchAnswers}
//         />
//       )}
//       <ToastContainer />
//     </Container>
//   );
// };

// export default Module;



import React, { useState, useEffect } from 'react';
import {
  Container, Grid, Button, Modal, Box, Typography,
  Table, TableBody, TableCell, TableContainer, TableHead,
  MenuItem, TableRow, Select, FormControl, InputLabel,
  IconButton, TextField, TablePagination, Divider, Paper,
  Chip, LinearProgress, Dialog, DialogTitle, DialogContent,
  DialogActions, CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CheckCircle, Cancel } from "@mui/icons-material";
import axios, { decryptData, encryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

// ── QuizResultModal (same as TeacherModule) ──────────────────────
const QuizResultModal = ({ open, onClose, studentName, assessmentId, studentId }) => {
  const [questions, setQuestions] = useState([]);
  const [myAnswers, setMyAnswers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && assessmentId && studentId) fetchData();
  }, [open, assessmentId, studentId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [qRes, aRes] = await Promise.all([
        axios.get(`assessment_questions/${assessmentId}`),
        axios.get(`quiz/results/${studentId}/${assessmentId}`),
      ]);
      setQuestions(qRes.data);
      setMyAnswers(aRes.data);
    } catch (err) {
      toast.error("Failed to load quiz result");
    } finally {
      setLoading(false);
    }
  };

  const totalMarks  = questions.reduce((s, q) => s + (q.marks || 0), 0);
  const earnedMarks = myAnswers.reduce((s, a) => s + (a.marksAwarded || 0), 0);
  const percentage  = totalMarks > 0 ? (earnedMarks / totalMarks) * 100 : 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { maxHeight: '90vh' } }}>
      <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" fontWeight="bold">Quiz Result — {studentName}</Typography>
            <Typography variant="body2" color="textSecondary">
              Score: {earnedMarks} / {totalMarks} ({percentage.toFixed(1)}%)
            </Typography>
          </Box>
          <Box display="flex" gap={1} alignItems="center">
            <Chip label={percentage >= 50 ? 'Passed' : 'Failed'}
              color={percentage >= 50 ? 'success' : 'error'} sx={{ fontWeight: 'bold' }} />
            <IconButton onClick={onClose}><CloseIcon /></IconButton>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={6}><CircularProgress /></Box>
        ) : (
          <>
            <Box sx={{
              background: percentage >= 50
                ? 'linear-gradient(135deg, #e8f5e9, #c8e6c9)'
                : 'linear-gradient(135deg, #ffebee, #ffcdd2)',
              borderRadius: 2, p: 3, mb: 3, textAlign: 'center'
            }}>
              <Typography variant="h3" fontWeight="bold"
                color={percentage >= 50 ? 'success.main' : 'error.main'}>
                {earnedMarks} / {totalMarks}
              </Typography>
              <Typography variant="h6" color="textSecondary">{percentage.toFixed(1)}%</Typography>
              <LinearProgress variant="determinate" value={percentage}
                sx={{ mt: 1.5, height: 12, borderRadius: 6 }}
                color={percentage >= 50 ? 'success' : 'error'} />
              <Typography mt={1.5} fontWeight="bold"
                color={percentage >= 50 ? 'success.main' : 'error.main'}>
                {percentage >= 50 ? '✓ Passed' : '✗ Failed'}
              </Typography>
            </Box>

            {questions.map((q, index) => {
              const ans = myAnswers.find(a => a.questionId === q.id);
              const isCorrect = ans?.isCorrect;
              const ansText = ans?.answer || 'No answer given';

              return (
                <Box key={q.id} sx={{
                  border: `2px solid ${isCorrect ? '#4caf50' : '#f44336'}`,
                  borderRadius: 2, p: 2.5, mb: 2,
                  backgroundColor: isCorrect ? '#f9fff9' : '#fff9f9'
                }}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                    <Box sx={{ flex: 1 }}>
                      <Typography fontWeight="bold">Q{index + 1}. {q.questionText}</Typography>
                      <Box display="flex" gap={1} mt={0.5}>
                        <Chip label={q.questionType} size="small" variant="outlined" />
                        <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
                          size="small" color="info" variant="outlined" />
                      </Box>
                    </Box>
                    <Chip icon={isCorrect ? <CheckCircle /> : <Cancel />}
                      label={isCorrect ? `+${ans?.marksAwarded} / ${q.marks}` : `0 / ${q.marks}`}
                      color={isCorrect ? 'success' : 'error'} sx={{ ml: 1, fontWeight: 'bold' }} />
                  </Box>

                  <Divider sx={{ mb: 1.5 }} />

                  {q.questionType === 'MCQ' && (
                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight="bold" mb={0.5} display="block">
                        OPTIONS
                      </Typography>
                      {q.options?.map((opt, i) => {
                        const isMyChoice = ansText === opt.optionText;
                        const isRight = opt.isCorrect;
                        let bg = 'transparent';
                        if (isRight) bg = '#e8f5e9';
                        if (isMyChoice && !isRight) bg = '#ffebee';
                        return (
                          <Box key={i} display="flex" alignItems="center" gap={1} mb={0.5} sx={{
                            backgroundColor: bg, borderRadius: 1, px: 1.5, py: 0.75,
                            border: `1px solid ${isRight ? '#4caf50' : isMyChoice ? '#f44336' : '#e0e0e0'}`
                          }}>
                            {isRight ? <CheckCircle sx={{ color: 'green', fontSize: 18 }} />
                              : isMyChoice ? <Cancel sx={{ color: 'red', fontSize: 18 }} />
                              : <Box sx={{ width: 18 }} />}
                            <Typography variant="body2" sx={{
                              fontWeight: (isRight || isMyChoice) ? 'bold' : 'normal', flex: 1
                            }}>{opt.optionText}</Typography>
                            {isMyChoice && !isRight && (
                              <Chip label="Student's answer" size="small" color="error"
                                sx={{ height: 20, fontSize: '0.7rem' }} />
                            )}
                            {isRight && (
                              <Chip label="Correct answer" size="small" color="success"
                                sx={{ height: 20, fontSize: '0.7rem' }} />
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  )}

                  {q.questionType === 'TRUE_FALSE' && (
                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight="bold" mb={1} display="block">
                        ANSWER
                      </Typography>
                      <Box display="flex" gap={2}>
                        {['True', 'False'].map(val => {
                          const correctAnswer = q.options?.find(o => o.isCorrect)?.optionText;
                          const isMyChoice = ansText === val;
                          const isRight = val === correctAnswer;
                          return (
                            <Box key={val} sx={{
                              border: `2px solid ${isRight ? '#4caf50' : isMyChoice ? '#f44336' : '#e0e0e0'}`,
                              borderRadius: 1, px: 2.5, py: 1,
                              backgroundColor: isRight ? '#e8f5e9' : isMyChoice ? '#ffebee' : 'transparent',
                              minWidth: 80, textAlign: 'center'
                            }}>
                              <Typography fontWeight={(isMyChoice || isRight) ? 'bold' : 'normal'}>{val}</Typography>
                              {isRight && <Typography variant="caption" color="success.main">✓ Correct</Typography>}
                              {isMyChoice && !isRight && <Typography variant="caption" color="error.main">✗ Student</Typography>}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  )}

                  {q.questionType === 'MATCH' && (() => {
                    let studentMap = {};
                    try { studentMap = JSON.parse(ansText); } catch (_) {}
                    return (
                      <Box>
                        <Typography variant="caption" color="textSecondary" fontWeight="bold" mb={1} display="block">
                          MATCH COMPARISON
                        </Typography>
                        {q.matchPairs?.map((pair, pi) => {
                          const studentRight = studentMap[pair.leftItem] || 'No answer';
                          const pairCorrect = studentRight === pair.rightItem;
                          return (
                            <Box key={pi} display="flex" gap={1} alignItems="center" mb={0.5} px={1} py={0.75} sx={{
                              backgroundColor: pairCorrect ? '#e8f5e9' : '#ffebee',
                              borderRadius: 1,
                              border: `1px solid ${pairCorrect ? '#4caf50' : '#f44336'}`
                            }}>
                              <Typography variant="body2" sx={{ flex: 1, fontWeight: 'bold' }}>{pair.leftItem}</Typography>
                              <Typography variant="body2" sx={{ width: 140, textAlign: 'center', color: pairCorrect ? 'success.main' : 'error.main', fontWeight: 'bold' }}>{studentRight}</Typography>
                              <Typography variant="body2" sx={{ width: 140, textAlign: 'center', color: 'success.main', fontWeight: 'bold' }}>{pair.rightItem}</Typography>
                              <Box sx={{ width: 50, textAlign: 'center' }}>
                                {pairCorrect
                                  ? <CheckCircle sx={{ color: 'green', fontSize: 20 }} />
                                  : <Cancel sx={{ color: 'red', fontSize: 20 }} />}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })()}

                  {q.questionType === 'SHORT_ANSWER' && (
                    <Box>
                      <Typography variant="caption" color="textSecondary" fontWeight="bold" mb={0.5} display="block">
                        STUDENT'S ANSWER
                      </Typography>
                      <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1.5, border: '1px solid #e0e0e0', minHeight: 60 }}>
                        <Typography variant="body2">{ansText}</Typography>
                      </Box>
                      <Chip label="⚠ Manually graded — update via submission panel"
                        size="small" color="warning" sx={{ mt: 1 }} />
                    </Box>
                  )}
                </Box>
              );
            })}
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ── ModalTable ───────────────────────────────────────────────────
const ModalTable = ({
  open, handleClose, data, externalStudents,
  answers, assessments, fetchAnswers, quizAnswers
}) => {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [score, setScore] = useState(null);
  const [comments, setComments] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [quizResultOpen, setQuizResultOpen] = useState(false);
  const [selectedQuizAssessmentId, setSelectedQuizAssessmentId] = useState(null);
  const [selectedStudentName, setSelectedStudentName] = useState('');
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  // ── KEY DIFFERENCE: admin uses decryptData from localStorage for approver
  const approver = decryptData(localStorage.getItem('name'));

  const handleScoreChange = (e) => {
    const v = e.target.value;
    if (v === "" || (/^\d+(\.\d{0,2})?$/.test(v) && Number(v) <= 100)) {
      setScore(v === "" ? null : Number(v));
    }
  };

  if (!data || !data.moduleName) return null;

  const moduleAssessments = assessments.filter(a => a.moduleName === data.moduleName);

  if (moduleAssessments.length === 0) {
    return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420, bgcolor: "background.paper",
          boxShadow: 24, p: 4, borderRadius: 2, textAlign: 'center'
        }}>
          <Typography variant="h6" fontWeight="bold" mb={1}>{data.moduleName}</Typography>
          <Typography color="textSecondary" mb={3}>No assessments available for this module.</Typography>
          <Button onClick={handleClose} variant="contained">Close</Button>
        </Box>
      </Modal>
    );
  }

  const studentsWithStatus = externalStudents.map(student => {
    const studentFileAnswers = answers.filter(
      a => a.studentId === student.id && a.moduleName === data.moduleName
    );

    const studentAssessments = moduleAssessments.map(assessment => {
      const isQuiz = assessment.assessmentType === 'QUIZ';
      if (isQuiz) {
        const quizForAssessment = quizAnswers.filter(
          a => a.studentId === student.id && a.trentAssessmentId === assessment.id
        );
        const quizSubmitted = quizForAssessment.length > 0;
        const earnedMarks = quizForAssessment.reduce((s, a) => s + (a.marksAwarded || 0), 0);
        return {
          assessmentId: assessment.id, description: assessment.description,
          assessmentType: 'QUIZ',
          status: quizSubmitted ? 'Completed' : 'Not Completed',
          submittedAt: quizSubmitted ? quizForAssessment[0]?.submittedAt : null,
          url: null, grade: quizSubmitted ? earnedMarks : null,
          comments: null, id: null,
        };
      } else {
        const fileAnswer = studentFileAnswers.find(a => a.trentAssessmentId === assessment.id);
        return {
          assessmentId: assessment.id, description: assessment.description,
          assessmentType: 'FILE',
          status: fileAnswer ? 'Completed' : 'Not Completed',
          submittedAt: fileAnswer ? fileAnswer.submittedAt : null,
          url: fileAnswer ? fileAnswer.url : null,
          grade: fileAnswer ? fileAnswer.grade : null,
          comments: fileAnswer ? fileAnswer.comments : null,
          id: fileAnswer ? fileAnswer.id : null,
        };
      }
    });

    return {
      studentId: student.id,
      student: student.name || student.student?.name,
      module: data.moduleName,
      assessments: studentAssessments,
    };
  });

  const filteredData = studentsWithStatus
    .filter(row => (row.student || '').toLowerCase().includes(search.toLowerCase()))
    .filter(row => !filter || row.assessments.some(a => a.status === filter));

  const handleSave = async () => {
    try {
      setLoading(true);
      await axios.put(`/submissions/update/${selectedId}`, {
        moduleName, grade: score, comments, approver,
      });
      toast.success("Mark updated successfully");
    } catch {
      toast.error("Failed to update mark");
    } finally {
      setLoading(false);
      setFileModalOpen(false);
      fetchAnswers();
    }
  };

  const handleViewFileClick = (assessment, row) => {
    setModuleName(row.module);
    setSelectedFile(assessment.url);
    setSelectedId(assessment.id);
    setScore(assessment.grade || 0);
    setComments(assessment.comments || "");
    setFileModalOpen(true);
  };

  const handleViewQuizClick = (assessment, row) => {
    setSelectedQuizAssessmentId(assessment.assessmentId);
    setSelectedStudentName(row.student);
    setSelectedStudentId(row.studentId);
    setQuizResultOpen(true);
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%", maxWidth: 1150, maxHeight: "90vh",
          bgcolor: "background.paper", boxShadow: 24,
          p: 4, borderRadius: 2, overflow: "auto",
        }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {data.moduleName} — Student Submissions
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {externalStudents.length} students · {moduleAssessments.length} assessments
              </Typography>
            </Box>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
          </Box>

          <Box display="flex" gap={2} mb={2}>
            <TextField label="Search by Student Name" variant="outlined" fullWidth size="small"
              value={search} onChange={e => setSearch(e.target.value)} />
            <FormControl fullWidth size="small">
              <InputLabel>Status Filter</InputLabel>
              <Select value={filter} label="Status Filter" onChange={e => setFilter(e.target.value)}>
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="Not Completed">Not Completed</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <TableContainer component={Paper} sx={{ maxHeight: 450, overflowY: "auto" }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 130 }}>Student Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Module</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Assessment</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Score</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Submitted At</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, rowIndex) =>
                      row.assessments.map((assessment, aIndex) => (
                        <TableRow key={`${rowIndex}-${aIndex}`}
                          sx={{ backgroundColor: assessment.status === 'Completed' ? '#f9fff9' : '#fff9f9' }}>
                          {aIndex === 0 && (
                            <TableCell rowSpan={row.assessments.length}
                              sx={{ fontWeight: 'bold', verticalAlign: 'middle', borderRight: '1px solid #e0e0e0' }}>
                              {row.student}
                            </TableCell>
                          )}
                          <TableCell>{row.module}</TableCell>
                          <TableCell>{assessment.description}</TableCell>
                          <TableCell>
                            <Chip label={assessment.assessmentType}
                              color={assessment.assessmentType === 'QUIZ' ? 'secondary' : 'primary'} size="small" />
                          </TableCell>
                          <TableCell>
                            <Chip label={assessment.status}
                              color={assessment.status === 'Completed' ? 'success' : 'default'}
                              size="small"
                              icon={assessment.status === 'Completed' ? <CheckCircle /> : undefined} />
                          </TableCell>
                          <TableCell>
                            {assessment.grade !== null && assessment.grade !== undefined ? (
                              <Chip label={`${assessment.grade} pts`} color="info" size="small" variant="outlined" />
                            ) : (
                              <Typography variant="body2" color="textSecondary">N/A</Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {assessment.submittedAt
                                ? new Date(assessment.submittedAt).toLocaleString()
                                : 'N/A'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            {assessment.assessmentType === 'FILE' && assessment.url && (
                              <Button variant="contained" color="primary" size="small"
                                onClick={() => handleViewFileClick(assessment, row)}>
                                View & Grade
                              </Button>
                            )}
                            {assessment.assessmentType === 'QUIZ' && assessment.status === 'Completed' && (
                              <Button variant="contained" color="secondary" size="small"
                                onClick={() => handleViewQuizClick(assessment, row)}>
                                View Quiz Result
                              </Button>
                            )}
                            {assessment.status === 'Not Completed' && (
                              <Chip label="Pending" color="warning" size="small" />
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography color="textSecondary">No data available</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
            count={filteredData.length} rowsPerPage={rowsPerPage} page={page}
            onPageChange={(e, n) => setPage(n)}
            onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} />

          <Button onClick={handleClose} variant="contained" sx={{ mt: 2 }}>Close</Button>
        </Box>
      </Modal>

      {/* FILE Grading Modal */}
      <Modal open={fileModalOpen} onClose={() => setFileModalOpen(false)}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: "70%" },
          height: { xs: "auto", md: "80%" },
          bgcolor: "background.paper", boxShadow: 24,
          p: { xs: 2, md: 4 }, borderRadius: 2,
          overflow: "hidden", display: "flex", flexDirection: "column",
        }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h5" fontWeight="bold" color="primary">Grading & File Preview</Typography>
            <IconButton onClick={() => setFileModalOpen(false)}><CloseIcon /></IconButton>
          </Box>
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, flexGrow: 1, gap: 2, overflowY: "auto" }}>
            <Box sx={{ flex: 1, p: 2, borderRight: { md: "1px solid #ccc" } }}>
              <Typography variant="h6">Enter Mark (out of 100)</Typography>
              <TextField type="text" fullWidth value={score} onChange={handleScoreChange}
                placeholder="e.g. 85"
                inputProps={{ pattern: "[0-9]*", inputMode: "numeric", maxLength: 5 }}
                sx={{ mt: 1 }} />
              <Typography variant="h6" sx={{ mt: 2 }}>Comments</Typography>
              <TextField multiline rows={4} fullWidth value={comments}
                onChange={e => setComments(e.target.value)}
                placeholder="Enter feedback for the student..."
                sx={{ mt: 1 }} />
              {score !== null && (
                <Box mt={2} p={1.5} sx={{ backgroundColor: score >= 50 ? '#e8f5e9' : '#ffebee', borderRadius: 1 }}>
                  <Typography fontWeight="bold" color={score >= 50 ? 'success.main' : 'error.main'}>
                    {score >= 50 ? '✓ Pass' : '✗ Fail'} — {score}/100
                  </Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ flex: 2, p: 2 }}>
              <Typography variant="h6" gutterBottom>File Preview</Typography>
              {selectedFile ? (
                <iframe src={selectedFile} width="100%" height="450px" title="Student Submission"
                  style={{ border: "1px solid #ccc", borderRadius: "8px" }} />
              ) : (
                <Typography color="textSecondary">No file available</Typography>
              )}
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
            <Button variant="outlined" onClick={() => setFileModalOpen(false)}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={handleSave}
              disabled={loading || score === null} sx={{ px: 3, py: 1 }}>
              {loading ? <CircularProgress size={22} color="inherit" /> : "Save Grade"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <QuizResultModal
        open={quizResultOpen}
        onClose={() => setQuizResultOpen(false)}
        studentName={selectedStudentName}
        assessmentId={selectedQuizAssessmentId}
        studentId={selectedStudentId}
      />
    </div>
  );
};

// ── A.jsx — Admin Assessment View ────────────────────────────────
// KEY DIFFERENCE vs TeacherModule:
//   - Receives batchDetails as a PROP (not from useParams)
//   - Gets intakeId from useParams (already available in Managebatch route)
//   - No TeachHeader (admin already has its own Header)
const A = ({ batchDetails }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [externalStudents, setExternalStudents] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [quizAnswers, setQuizAnswers] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [allAssessments, setAllAssessments] = useState([]);

  // intakeId comes from the parent route /Managebatches/:batchId/:intakeId
  const { intakeId } = useParams();
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const batchId1  = batchDetails?.batchId || batchDetails?.id;

  const handleOpen = (index) => {
    setOpenIndex(index);
    fetchAssessments(batchDetails.moduleDetails[index].moduleName);
  };
  const handleClose = () => setOpenIndex(null);

  const fetchAssessments = async (moduleName) => {
    try {
      const res = await axios.get(`trent_assessments/${batchId1}/${moduleName}`);
      setAssessments(res.data);
    } catch { setAssessments([]); }
  };

  const fetchAllAssessments = async () => {
    try {
      const res = await axios.get(`trent_assessments/${batchId1}`);
      setAllAssessments(res.data);
    } catch { }
  };

  const fetchStudentsByIntake = async () => {
    try {
      const res = await axios.get(`/registrationadvances/active/${intakeId1}`);
      setExternalStudents(res.data);
    } catch { }
  };

  const fetchAnswers = async () => {
    try {
      const res = await axios.get(`submissions/intake/${intakeId1}`);
      setAnswers(res.data);
    } catch { }
  };

  const fetchQuizAnswers = async () => {
    try {
      const res = await axios.get(`quiz/results/intake/${intakeId1}`);
      setQuizAnswers(res.data);
    } catch { }
  };

  useEffect(() => {
    if (!batchId1 || !intakeId1) return;
    fetchStudentsByIntake();
    fetchAnswers();
    fetchQuizAnswers();
    fetchAllAssessments();
  }, [batchId1, intakeId1]);

  const getModuleStats = (moduleName) => {
    const moduleAssessmentList = allAssessments.filter(a => a.moduleName === moduleName);
    if (moduleAssessmentList.length === 0) return null;

    const totalExpected = externalStudents.length * moduleAssessmentList.length;
    let submittedCount = 0;

    moduleAssessmentList.forEach(assessment => {
      if (assessment.assessmentType === 'QUIZ') {
        submittedCount += new Set(
          quizAnswers.filter(a => a.trentAssessmentId === assessment.id).map(a => a.studentId)
        ).size;
      } else {
        submittedCount += new Set(
          answers.filter(a => a.trentAssessmentId === assessment.id && a.moduleName === moduleName)
            .map(a => a.studentId)
        ).size;
      }
    });

    return { submitted: submittedCount, total: totalExpected };
  };

  if (!batchDetails?.moduleDetails) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Typography variant="h6" fontWeight="bold" textAlign="center" mb={0.5}>
        Student Submissions
      </Typography>
      <Typography variant="body2" color="textSecondary" textAlign="center" mb={2}>
        {externalStudents.length} students enrolled · Select a module to view submissions
      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {batchDetails.moduleDetails.map((module, index) => {
          const stats = getModuleStats(module.moduleName);
          return (
            <Grid item xs={12} sm={6} md={4} key={module.id}>
              <Button variant="outlined" fullWidth onClick={() => handleOpen(index)} sx={{
                minHeight: "90px", display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center", textAlign: "center",
                fontSize: "0.95rem", fontWeight: 'bold', padding: "12px 16px",
                whiteSpace: "normal", wordBreak: "break-word", borderRadius: 2, borderWidth: 2,
                '&:hover': { backgroundColor: '#e3f2fd', borderWidth: 2 }
              }}>
                {module.moduleName}
                <Box mt={0.5} display="flex" gap={0.5} justifyContent="center">
                  {stats === null ? (
                    <Chip label="No assessments" size="small" color="default"
                      sx={{ fontSize: '0.7rem', height: 20 }} />
                  ) : (
                    <Chip
                      label={`${stats.submitted}/${stats.total} submitted`}
                      size="small"
                      color={
                        stats.submitted === stats.total && stats.total > 0 ? 'success'
                          : stats.submitted > 0 ? 'warning' : 'default'
                      }
                      sx={{ fontSize: '0.7rem', height: 20 }}
                    />
                  )}
                </Box>
              </Button>
            </Grid>
          );
        })}
      </Grid>

      {openIndex !== null && (
        <ModalTable
          open={true}
          handleClose={handleClose}
          data={batchDetails.moduleDetails[openIndex]}
          externalStudents={externalStudents}
          answers={answers}
          quizAnswers={quizAnswers}
          assessments={assessments}
          fetchAnswers={fetchAnswers}
        />
      )}

      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
    </Box>
  );
};

export default A;